import styled, { css } from "styled-components";

export { Button, Loading } from "styles/styled-components";

export const Container = styled.section`
  width: 100%;
  max-width: 1280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 72px 32px;
  margin: 0 auto;
`;

export const Content = styled.div`
  width: 100%;
  max-width: 590px;
  display: flex;
  flex-direction: column;
  align-items: center;

  form {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding-top: 32px;
    margin-top: 32px;
    border-top: 2px #c7d0dd solid;

    button {
      align-self: center;
      min-width: 200px;
    }
  }

  @media screen and (max-width: 900px) {
    max-width: 480px;
  }

  @media screen and (max-width: 414px) {
    form {
      button {
        width: 100%;
      }
    }
  }
`;

export const Title = styled.h2`
  font-size: 46px;
  line-height: 46px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.colors.black};
  text-align: center;

  span {
    color: ${({ theme }) => theme.colorScheme.primary};
  }

  @media screen and (max-width: 900px) {
    text-align: center;
  }

  @media screen and (max-width: 414px) {
    font-size: 30px;
    line-height: 30px;
  }
`;

export const Text = styled.article`
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  width: 100%;
  max-width: 480px;

  p {
    margin-bottom: 16px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  @media screen and (max-width: 900px) {
    text-align: center;
  }

  @media screen and (max-width: 414px) {
    font-size: 16px;
  }
`;

export const Row = styled.div<{ border?: boolean }>`
  width: 100%;
  display: flex;
  column-gap: 16px;
  ${({ border }) =>
    border &&
    css`
      border-bottom: 2px #c7d0dd solid;
      padding-bottom: 16px;
      margin-bottom: 32px;
    `};

  @media screen and (max-width: 414px) {
    flex-direction: column;
  }
`;
